import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 *
 * */
@Component({
  selector: 'campfire-homepage-instructions-modal',
  templateUrl: './homepage-instructions.modal.component.html',
  styleUrls: ['./homepage-instructions.modal.component.scss']
})
export class HomePageInstructionsModalComponent {
  constructor(private modal: NgbActiveModal) {

  }
}

